module.exports = __webpack_public_path__ + "static/media/title-danny.8bf9b6bc.jpg";